export default {
  init: process.env.BASE_URL + '/api/modules/bargain/index',
  submit: process.env.BASE_URL + '/api/modules/bargain/submit',
  bargaining: process.env.BASE_URL + '/api/modules/bargain/bargaining',
  rankList: process.env.BASE_URL + '/api/modules/bargain/rank_list2',
  friendList: process.env.BASE_URL + '/api/modules/bargain/friend_list',
  myAward: process.env.BASE_URL + '/api/modules/bargain/my_award',
  purchase: process.env.BASE_URL + '/api/modules/bargain/purchase',
  broadcast: process.env.BASE_URL + '/api/modules/bargain/broadcast',
}